export const EMPLOYEEFACE_LOADING = "EMPLOYEEFACE_LOADING";
export const EMPLOYEEFACE_RESET = "EMPLOYEEFACE_RESET";
export const GET_EMPLOYEEFACE = "GET_EMPLOYEEFACE";
export const GET_EMPLOYEEFACE_SUCCESS = "GET_EMPLOYEEFACE_SUCCESS";
export const GET_EMPLOYEEFACE_FAIL = "GET_EMPLOYEEFACE_FAIL";
export const DELETE_EMPLOYEEFACE = "DELETE_EMPLOYEEFACE"
export const DELETE_EMPLOYEEFACE_SUCCESS = "DELETE_EMPLOYEEFACE_SUCCESS"
export const DELETE_EMPLOYEEFACE_FAIL = "DELETE_EMPLOYEEFACE_FAIL"
export const UPDATE_EMPLOYEEFACE = "UPDATE_EMPLOYEEFACE"
export const UPDATE_EMPLOYEEFACE_SUCCESS = "UPDATE_EMPLOYEEFACE_SUCCESS"
export const UPDATE_EMPLOYEEFACE_FAIL = "UPDATE_EMPLOYEEFACE_FAIL"
export const ADD_NEW_EMPLOYEEFACE = "ADD_NEW_EMPLOYEEFACE"
export const ADD_EMPLOYEEFACE_SUCCESS = "ADD_EMPLOYEEFACE_SUCCESS"
export const ADD_EMPLOYEEFACE_FAIL = "ADD_EMPLOYEEFACE_FAIL"